module.exports = __webpack_public_path__ + "static/media/BrandGuidelines.e66cb150.pdf";